export default __webpack_public_path__ + "static/media/Scarhide Helm.dc6b3d90.jpg";